import { render, staticRenderFns } from "./ClippedTabReadOnly.vue?vue&type=template&id=94e97fce&"
import script from "./ClippedTabReadOnly.vue?vue&type=script&lang=js&"
export * from "./ClippedTabReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports